let baseUrl = "https://stage-app-api.lambdatestinternal.com/lt/v1.0/audit";
if (process.env.REACT_APP_ENV === "prod") {
  baseUrl = "https://manual-api.lambdatest.com/lt/v1.0/audit";
}
if (process.env.REACT_APP_ENV === "stage") {
  baseUrl = "https://stage-app-api.lambdatestinternal.com/lt/v1.0/audit";
}
export { baseUrl };
